<template lang="pug">
.cp-robot
  template(v-if="robot3Show")
    transition(name="fadeUp")
      .tabs.fixed(v-show="!isTabsVisible")
        router-link(:to="'/robot3s/info'") 机器人
        router-link(:to="'/robot3s/design'") 平台
        router-link(:to="'/robot3s/spec'") 技术规格
    .tabs#tabs
      router-link(:to="'/robot3s/info'") 机器人
      router-link(:to="'/robot3s/design'") 平台
      router-link(:to="'/robot3s/spec'") 技术规格
    router-view
  template(v-else)
    #robot3s-default-banner
      .w
        .p1.fadeUp(v-if="isMobile") 
          |11.15日
          br
          |深圳新品发布会
        .p1.fadeUp(v-else) 11.15日·深圳新品发布会
        .p2.fadeDown.delay1
</template>

<script>
import { isVisible } from '../../../common/utils'

export default {
  data () {
    return {
      isTabsVisible: true,
      robot3Show: DB.robot3Show,
    }
  },
  computed: {},
  methods: {
    handleTab (index) {
      this.tab = index
    }
  },
  created () {
    if (this.robot3Show) {
      $(window).on('scroll', () => {
        this.isTabsVisible = isVisible('#tabs')
      })
    }
  }
}
</script>

<style lang="stylus">
@import 'config'
.cp-robot
  .tabs
    width 100%
    text-align center
    height 48px
    line-height 48px
    border-top 1px solid $bdcolor
    box-shadow 0 3px 10px $bdcolor
    &.fixed
      position fixed
      top 0
      left 0
      background rgba(255,255,255,.8)
      z-index 10
    a
      display inline-block
      margin 0 18px
      cursor pointer
      font-size 14px
      &.router-link-active
        color $blue
  #robot3s-default-banner
    min-width 1200px
    height 800px
    background url('../../../assets/web/3-banner-default.jpg') no-repeat center
    background-size auto 100%
    text-align center
    .w
      padding-top 306px
    .p1
      color #fff
      font-size 40px
    .p2
      margin-top 120px
      font-size 24px
      color #4ce2af
.is-mobile
  #robot3s-default-banner
    min-width 100%
    background-image url('../../../assets/mobile/3-banner-default.jpg')
    height r(1100)
    .w
      padding-top r(400)
    .p1
      font-size r(40)
    .p2
      margin-top r(120)
      font-size r(20)
</style>



// WEBPACK FOOTER //
// src/views/robot/3s/index.vue